/** En feil fra API-et. `kode` er den stabile koden (snake_case) som nettsidene oversetter. */
export class ApiFeil extends Error {
  constructor(
    public readonly status: number,
    public readonly kode: string
  ) {
    super(`${status} ${kode}`);
  }
}

/**
 * Kaller API-et med informasjonskapselen for økten. Under utvikling sender Create React App `/api` videre til
 * API-et (proxy i package.json).
 */
export async function api<T>(sti: string, metode: 'GET' | 'POST' | 'PUT' | 'PATCH' = 'GET', data?: unknown): Promise<T> {
  let svar: Response;
  try {
    svar = await fetch(sti, {
      method: metode,
      credentials: 'same-origin',
      headers: data === undefined ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: data === undefined ? undefined : JSON.stringify(data),
    });
  } catch {
    throw new ApiFeil(0, 'nettverk');
  }

  if (!svar.ok) {
    let kode = 'ukjent';
    try {
      const problem = await svar.json();
      if (typeof problem?.kode === 'string') kode = problem.kode;
    } catch {
      // Svaret var ikke JSON
    }
    throw new ApiFeil(svar.status, kode);
  }

  if (svar.status === 204) return undefined as T;
  return (await svar.json()) as T;
}
